import { hasInStoreOnlyTag } from './availability';

const BADGE_SELECTOR = '[data-click-collect-only-badge]';

export function updateClickCollectOnlyBadge({ onlineQuantity, tags = [] } = {}) {
  const badges = document.querySelectorAll(BADGE_SELECTOR);
  if (!badges.length) return;

  const shouldShow =
    onlineQuantity != null &&
    Number(onlineQuantity) === 0 &&
    !hasInStoreOnlyTag(tags);

  badges.forEach((badge) => {
    badge.hidden = !shouldShow;
    badge.classList.toggle('hidden', !shouldShow);
  });
}
